<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.03.01</b> - Some long-awaited QoL improvements</p>
    <div class="ml-5 pb-4 text-green-700">
      <div class="font-bold mt-2">QoL</div>
      <ul class="ml-4 list-disc">
        <li>Added ability to downgrade abilities and refund ability points</li>
        <li>Added ability to downgrade attributes and refund attribute points</li>
        <li>Added duplicate hero build feature to quickly copy your existing builds</li>
        <li>Added client version check system to notify players when updates are available</li>
      </ul>

      <div class="font-bold mt-2">Bug Fixes</div>
      <ul class="ml-4 list-disc">
        <li>Fixed item duping and disappearance bugs when equipping bags to inventory slots</li>
        <li>Fixed crashes that could occur when rendering certain combat conditions</li>
      </ul>
    </div>
  </div>
</template>
